import React from "react";
import { AccountSidebar } from "./HeaderData";
import { NavLink } from "react-router-dom";

const Accountsidebar = () => {

  const renderMenuItem = (item) => {
    return (
      <>
        <div
          key={item.label}
          className="py-2 px-4 cursor-pointer hover:text-white text-black hover:bg-primary"
        >
          <NavLink to={item.href}>
            <div className="flex items-center">
              <img src={item.icon} alt="icon" className="w-5 h-5 mr-2"></img>
              <span className="text-sm">{item.label}</span>
            </div>
          </NavLink>
        </div>
        <hr className="text-[#d4d0d0]" />
      </>
    );
  };

  return (
    <nav className="w-full bg-white overflow-y-scroll text-black hide-scrollbar md:w-auto sticky top-[120px] lg:block hidden lg:h-[85vh]">
      <div className="p-1.5 bg-[#DBDADA] text-offwhite text-[13px] font-semibold">
        Main Menu
      </div>
      <div className="pt-2.5">
        {AccountSidebar?.map((item) => renderMenuItem(item))}
      </div>
    </nav>
  );
};

export default Accountsidebar;
